export default {
  renoUrl: {
    addPage: "/decorate/page/create",//新增装修页面
    delPage:"/decorate/page/delete",//删除页面
    getPageList: "/decorate/page/query",//查询装修页面列表,
    getComList:"/decorate/system/component/query",//获取全局组件列表
    getAdminPageList: "/decorate/page/queryAdminPage",//查询装修系统页面列表
    choosePage:"/decorate/page/choosePage",//查询选择页面
    changePageUrl:"/decorate/page/updateUrl",//修改页面url
    copyPage:"/decorate/page/copy",//复制页面
    queryHistory:"/decorate/channel/queryHistory",//历史查询,
    queryComHistory:"/decorate/system/component/queryHistory",//全局组件历史版本查询
    rollBack:'/decorate/channel/rollBack',//版本回滚
    rollComBack:'/decorate/system/component/rollBack',//全局组件版本回滚
    createChannel:"/decorate/channel/create",//新增渠道,
    createComChannel:'/decorate/system/component/copy',//新增全局渠道
    delChannel:"/decorate/channel/delete",//删除渠道,
    delComChannel:"/decorate/system/component/delete",//系统组件删除渠道
    editChannel:"/decorate/component/list",//编辑渠道
    editCom:"/decorate/system/component/detail",//编辑全局组件
    updateCom:"/decorate/system/component/update",//更新组件渠道id
    saveCom:'/decorate/system/component/save',//全局组件保存
    pubCom:'/decorate/system/component/online/',//全局组件发布
    modifyComponent:"/decorate/component/modify",//批量修改组件
    createComponent:"/decorate/component/create",//创建一个组件
    deleteComponent:"/decorate/component/delete",//删除一个组件
    offlineChannel:"/decorate/channel/offline",//下线渠道
    onlineChannel:"/decorate/channel/online",//发布渠道
    updateChannel:"/decorate/channel/update",//更新渠道
    getGoodsList:"/goods/item/getItems",//获取商品列表
    getColGoodsList: "/promotion/platform/common/getAuditPassValidGoodsList/",
    getGoods:"/goods/item/queryItems",//根据商品id和名称模糊搜索获取所有商品id和名称
    getStores:"/merchant/storeInfo/getStoreInfoLists",//根据店铺id和名称模糊搜索获取所有店铺id和名称      
    getBrands:"/goods/brand/queryBrand",//根据品牌id和名称模糊搜索获取所有品牌id和名称
    uploadGoodsList:"/decorate/upload/importGoods",//上传商品excel
    autoOffOrOnlineTime:"/decorate/channel/autoOffOrOnlineTime",//设置或修改上线时间和下线时间
    updateShare: "/decorate/page/updateShare",//设置微信分享
    getAllCoupon:'/promotion/coupon/platform/template/getGrantListForDecorate',//获取优惠券列表
    getContentList: '/content/content/queryContents',//获取图文/测评列表
    getAllAuthors: 'content/author/getAllAuthors',//获取全部作者/来源
    getContents:"/content/content/getContents/",//根据条件自动获取内容列表
    getDecTopic:"/decorate/content/component/",//装修选择栏目信息
    // getAuditPassValidGoodsListOperate:"promotion/collage/platform/getAuditPassValidGoodsList"
    getAuditPassValidGoodsListOperate:"goods/item/getItems",
    couponBagSave:"/promotion/coupon/platform/couponBag/save",  //新人优惠券更改
    releaseCouponBag:"/promotion/coupon/platform/couponBag/release",  //发布优惠券
  }
};
